import TimerJS from "~/components/ui/TimerJS"
import { useId } from "react"
import type { HTMLWidget } from "~/types/widgets"

export interface Props {
    /**
     * @title Texto
     * @default Tempo restante para o fim da campanha
     */
    text?: HTMLWidget
    /**
     * @title Expira em
     * @format date-time
     */
    expiresAt?: string
    labels?: {
        /**
         * @title Texto de expirado
         * @description Texto exibido quando a campanha expirar
         */
        expired?: string
        /**
         * @title Texto de horas
         * @description Texto exibido ao lado das horas
         */
        hours?: string
        /**
         * @title Texto de minutos
         * @description Texto exibido ao lado dos minutos
         */
        minutes?: string
        /**
         * @title Texto de segundos
         * @description Texto exibido ao lado dos segundos
         */
        seconds?: string
    }
    link?: {
        /**
         * @title Texto do link
         * @default button
         */
        text: string
        /**
         * @title Link
         * @default #
         */
        href: string
    }

    layout?: {
        /**
         * @title Posição do texto
         * @default Antes do contador
         */
        textPosition?: 'Antes do contador' | 'Depois do contador'
    }
}

function CampaignTimer({
    expiresAt = `${new Date()}`,
    labels,
    text = 'Time left for a campaign to end wth a link',
    link = { text: 'Click me', href: '/hello' },
    layout = { textPosition: 'Antes do contador' },
}: Props) {
    const id = useId()

    return (
        <>
            <div className='bg-accent text-accent-content'>
                <div className='container mx-auto flex flex-col lg:flex-row lg:items-center lg:justify-center lg:gap-16 py-4 px-6 gap-4 '>
                    {layout?.textPosition !== 'Depois do contador' && (
                        <div
                            className='text-sm text-center lg:text-xl lg:text-left lg:max-w-lg'
                            dangerouslySetInnerHTML={{ __html: text }}
                        >
                        </div>
                    )}
                    <div
                        id={`${id}::expired`}
                        className='hidden text-sm text-center lg:text-xl lg:text-left lg:max-w-lg'
                    >
                        {labels?.expired || 'Expired!'}
                    </div>
                    <div className='flex gap-8 lg:gap-16 items-center justify-center lg:justify-normal'>
                        <div id={`${id}::counter`}>
                            <div className='grid grid-flow-col gap-3 text-center auto-cols-max items-center'>
                                <div className='flex flex-col text-xs lg:text-sm'>
                                    <span className='countdown font-normal text-xl lg:text-2xl'>
                                        <span id={`${id}::hours`} />
                                    </span>
                                    {labels?.hours || ''}
                                </div>
                                <div>:</div>
                                <div className='flex flex-col text-xs lg:text-sm'>
                                    <span className='countdown font-normal text-xl lg:text-2xl'>
                                        <span id={`${id}::minutes`} />
                                    </span>
                                    {labels?.minutes || ''}
                                </div>
                                <div>:</div>
                                <div className='flex flex-col text-xs lg:text-sm'>
                                    <span className='countdown font-normal text-xl lg:text-2xl'>
                                        <span id={`${id}::seconds`} />
                                    </span>
                                    {labels?.seconds || ''}
                                </div>
                            </div>
                        </div>
                        <div
                            className={`hidden text-sm text-center lg:text-xl lg:text-left lg:max-w-lg ${
                                layout?.textPosition === 'Depois do contador'
                                    ? 'lg:block'
                                    : 'lg:hidden'
                            }`}
                            dangerouslySetInnerHTML={{ __html: text }}
                        >
                        </div>
                        <a className='btn' aria-label={link.text} href={link.href}>
                            {link.text}
                        </a>
                    </div>
                    <div
                        className={`lg:hidden text-sm text-center lg:text-xl lg:text-left lg:max-w-lg ${
                            layout?.textPosition === 'Depois do contador' ? 'block' : 'hidden'
                        }`}
                        dangerouslySetInnerHTML={{ __html: text }}
                    >
                    </div>
                </div>
            </div>
            <TimerJS rootId={id} expiresAt={expiresAt} />
        </>
    )
}

export default CampaignTimer
export { default as LoadingFallback } from "~/components/LoadingFallback"
